import { leadConstant } from '../constants';

const initialState = {
  statuses: [],
  members: [],
  loadingStatuses: false,
  loadingMembers: false,
};

export default function leadReducer(state = initialState, action) {
  switch (action.type) {
    case leadConstant.SET_LEAD_STATUSES:
      return {
        ...state,
        statuses: action.payload,
      };
    
    case leadConstant.SET_AGENCY_MEMBERS:
      return {
        ...state,
        members: action.payload,
      };
    
    case leadConstant.LOADING_LEAD_STATUSES:
      return {
        ...state,
        loadingStatuses: action.payload,
      };
    
    case leadConstant.LOADING_AGENCY_MEMBERS:
      return {
        ...state,
        loadingMembers: action.payload,
      };
    
    default:
      return state;
  }
}
